class MobileNav {
	init() {
		// TODO: Resize event that adjusts body class based on the expanded setting.
		const body = document.querySelector('body') as HTMLElement;

		const mobileNavToggle = document.querySelectorAll(
			'.main-header__mobile-nav-toggle'
		) as NodeListOf<HTMLElement>;
		mobileNavToggle.forEach((el) => {
			el.addEventListener('click', () => {
				if (body.classList.contains('mobile-nav-open')) {
					body.classList.remove('mobile-nav-open');
				} else {
					body.classList.add('mobile-nav-open');
				}
			});
		});
	}
}

export default new MobileNav();
